function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
var SearchPopularQueries = /*#__PURE__*/function (_React$Component) {
  function SearchPopularQueries(props) {
    var _this;
    _classCallCheck(this, SearchPopularQueries);
    _this = _callSuper(this, SearchPopularQueries, [props]);
    _this.state = {
      popularQueries: [],
      showPopularQueries: false,
      holdUp: false
    };
    return _this;
  }
  _inherits(SearchPopularQueries, _React$Component);
  return _createClass(SearchPopularQueries, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var filterWithPopularQueries = this.props.filters.filter(function (filter) {
        return filter.name === "Popular queries";
      });
      var popularQueries = filterWithPopularQueries[0].elements;
      this.setState({
        popularQueries: popularQueries
      });
      this.props.searchInputRef.current.addEventListener("click", function () {
        _this2.setState({
          showPopularQueries: true,
          holdUp: true
        });
        setTimeout(function () {
          _this2.setState({
            holdUp: false
          });
        }, 300);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState) {
      if (previousProps.pageScrollOffset !== this.props.pageScrollOffset && previousState.showPopularQueries && !previousState.holdUp) {
        this.setState({
          showPopularQueries: false
        });
      }
    }
  }, {
    key: "handleOnClick",
    value: function handleOnClick(e, query) {
      e.preventDefault();
      if (query.name !== this.props.searchQuery) {
        this.props.handleSearch(query.name, true, "popular_searches");
      }
    }
  }, {
    key: "handleClosePopularQueries",
    value: function handleClosePopularQueries(e) {
      e.preventDefault();
      this.setState({
        showPopularQueries: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        title = _this$props.title,
        searchQuery = _this$props.searchQuery;
      var _this$state = this.state,
        popularQueries = _this$state.popularQueries,
        showPopularQueries = _this$state.showPopularQueries;
      return /*#__PURE__*/React.createElement("div", {
        className: "resource-center__search__popular-queries ".concat(showPopularQueries ? "show" : "")
      }, /*#__PURE__*/React.createElement("p", {
        className: "resource-center__search__popular-queries__title",
        dangerouslySetInnerHTML: {
          __html: title + ":"
        }
      }), popularQueries.map(function (query) {
        return /*#__PURE__*/React.createElement("button", {
          key: query.id,
          dangerouslySetInnerHTML: {
            __html: query.name
          },
          onClick: function onClick(e) {
            return _this3.handleOnClick(e, query);
          },
          className: "".concat(searchQuery === query.name ? "active" : "")
        });
      }), /*#__PURE__*/React.createElement("button", {
        className: "resource-center__search__popular-queries__close-btn",
        onClick: function onClick(e) {
          return _this3.handleClosePopularQueries(e);
        }
      }));
    }
  }]);
}(React.Component);
export default SearchPopularQueries;